import useAlertMessage from "hooks/useAlertMessage";
import useToast from "hooks/useToast";
import React from "react";
import {
  UseFieldArrayReturn,
  UseFormReset,
  UseFormResetField,
  UseFormSetValue,
} from "react-hook-form";
import {DeleteLogisticVoyage} from "services/api_v2/Processes/Processes.service";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {
  Voyage,
  VoyageToSend,
} from "views/ProcessDetails/refactor/types/voyages.types";
import {DeletionConfirmationConfig} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/hooks/useVoyageDeletionConfirmation";
import {useVoyageDeletionFlow} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/hooks/useVoyageDeletionFlow";

export type VoyageDeletionDependencies = {
  remove: UseFieldArrayReturn<Process, "boarding.voyages">["remove"];
  addNewVoyage: (
    id: number,
    voyage: Partial<VoyageToSend>,
  ) => Promise<Process | undefined>;
  refetchProcess: () => Promise<Process | undefined>;
  reset: UseFormReset<Process>;
  resetField: UseFormResetField<Process>;
  setValue: UseFormSetValue<Process>;
  processId: number;
  allVoyages: Voyage[];
  openDeletionConfirmation: (
    event: React.MouseEvent<HTMLElement>,
    {voyage, onConfirm}: DeletionConfirmationConfig,
  ) => void;
};

const useVoyageDeletion = (dependencies: VoyageDeletionDependencies) => {
  const [showToast] = useToast();
  const [showAlert] = useAlertMessage();

  const {executeDeletionFlow} = useVoyageDeletionFlow(dependencies);

  const deleteVoyage = async (voyage: Voyage, index: number) => {
    if (!voyage.id) {
      return;
    }

    try {
      await DeleteLogisticVoyage(voyage.id);
      dependencies.remove(index);
      showToast("Viagem removida com sucesso", "success");
      return true;
    } catch (error: any) {
      console.error(error);
      showAlert(error?.response?.data?.message);
      return false;
    }
  };

  const handleDeleteVoyage = (
    event: React.MouseEvent<HTMLElement>,
    voyage: Voyage,
    index: number,
  ) => {
    dependencies.openDeletionConfirmation(event, {
      voyage,
      index,
      onConfirm: async () => {
        const deleted = await deleteVoyage(voyage, index);
        if (deleted) {
          executeDeletionFlow(voyage, index);
        }
      },
    });
  };

  return {
    handleDeleteVoyage,
    deleteVoyage,
  };
};

export default useVoyageDeletion;
